import { combineReducers } from 'redux';

import { reducer as authReducer } from './auth';
import { reducer as crudReducer } from './crud';
import { reducer as crmReducer } from './crm';
import { reducer as trmReducer } from './trm';
// import { reducer as adavancedCrudReducer } from './adavancedCrud';
import { reducer as settingsReducer } from './settings';
import { reducer as translateReducer } from './translate';
import { reducer as gymReducer } from './gym';
import { reducer as rolesReducer } from './roles';
import { reducer as employeesReducer } from './employees';
import { reducer as statisticsReducer } from './statistics';
import { reducer as chatReducer } from './chat';

// Combine all reducers.

const rootReducer = combineReducers({
  auth: authReducer,
  crud: crudReducer,
  gym: gymReducer,
  crm: crmReducer,
  trm: trmReducer,
  roles: rolesReducer,
  statistics: statisticsReducer,
  settings: settingsReducer,
  translate: translateReducer,
  employees: employeesReducer,
  chat: chatReducer,
});

export default rootReducer;
